const debug_style = "height: 6px; width: 6px; border-radius: 3px; background-color: red; position: absolute;";

export default `
    <div id="js_debug_left_eye" class="debug-point" style="${debug_style}"></div>
    <div id="js_debug_right_eye" class="debug-point" style="${debug_style}"></div>
    <div id="js_debug_center_eye" class="debug-point" style="${debug_style}"></div>
    <div id="js_debug_left_ear" class="debug-point" style="${debug_style}"></div>
    <div id="js_debug_right_ear" class="debug-point" style="${debug_style}"></div>
    <div id="js_debug_joint_left" class="debug-point" style="${debug_style}"></div>
    <div id="js_debug_joint_right" class="debug-point" style="${debug_style}"></div>
`;